/* eslint-disable */
import React from 'react';
import { BsFillCircleFill, BsCheck } from 'react-icons/bs';
import ClipLoader from 'react-spinners/ClipLoader';

import './style.css';
import '../../App.css';

import { Header, QuestionComponent } from '../../Components';

const CarInsuranceQuestionnaireScreen = ({
  questions,
  answers,
  handleAnswerChange,
  handleSubmit,
  loading,
  canSubmit,
}) => {
  return (
    <div className="car-insurance-lead-main-container">
      <div>
        <div style={{ marginBottom: '-13px', width: '100%' }}>
          <Header title={true} />
        </div>
        <div className="car-insurance-lead-container">
          <div className="car-insurance-lead-tag">
            <span className="icon-stack">
              <BsFillCircleFill />
              <BsCheck />
            </span>
            <span style={{ marginLeft: '8px' }}>Vehicle inspection completed</span>
          </div>
          <div className="form-container">
            <div className="form-header">
              <h1 className={"car-insurance-lead-header-title"}>Car Insurance Lead Qualification Form</h1>
              <p>Please complete the questionnaire below after vehicle inspection</p>
            </div>
            <form>
              <div className="question-main-div">
                {questions.map(question => (
                  <QuestionComponent
                    key={question.id}
                    question={question}
                    answers={answers}
                    handleAnswerChange={handleAnswerChange}
                  />
                ))}
                <div className="car-insurance-lead-bottom-content">
                  <div
                    className={`car-insurance-lead-submit-button${!canSubmit || loading ? ' disabled' : ''}`}
                    onClick={!loading && canSubmit ? handleSubmit : null}
                    style={!canSubmit || loading ? { background: '#C2C2C2', cursor: 'not-allowed' } : {}}
                  >
                    {loading ? (
                      <ClipLoader color={'white'} size={20} />
                    ) : (
                      <div className="car-insurance-lead-submit-button-text">Submit Questionnaire</div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarInsuranceQuestionnaireScreen;
